<template>
    <RightSidebar v-if="!appData.isMobile">
        <div class="col-12" v-if="type == Enums.RIGHT_TYPE.DASHBOARD && data">
            <PreviewCard css="text-yellow" icon="icon-user-graduate" title="Öğrenci">
                <div class="mb-3">
                    <img class="rounded-circle me-2" :src="Web.Media(data.student.profile, Web.Url(appData.default.profile))" width="32" height="32" />
                    <span class="name b-500 text-default fs-4">{{ data.student.fullName }}</span>
                </div>
                <div>
                    <div class="name b-500 text-default fs-4 mb-2"><b class="me-2">Sınav Türü:</b>{{data.student.lessonAreaName}}</div>
                    <div class="name b-500 text-default fs-4 mb-2"><b class="me-2">Alan:</b>{{data.student.lessonGroupName}}</div>
                    <div class="name b-500 text-default fs-4 mb-2"><b class="me-2">Sınıf:</b>{{data.student.classRoomName}}</div>
                    <div class="name b-500 text-default fs-4 mb-2"><b class="me-2">Hedef:</b>{{data.student.target}}</div>
                    <div class="name b-500 text-default fs-4 mb-2" v-if="!Text.IsEmpty(data.student.phoneNumber)">
                        <b class="me-2">Telefon:</b>
                        <a :href="'tel:+9' + appData.fn.phoneFormat(data.student.phoneNumber).replace(/ /g, '')">{{appData.fn.phoneFormat(data.student.phoneNumber)}}</a>
                    </div>
                    <hr />
                    <div class="name b-500 text-default fs-4 mb-2"><b class="me-2">Veli:</b>{{data.student.parentFullName}}</div>
                    <div class="name b-500 text-default fs-4" v-if="!Text.IsEmpty(data.student.parentPhoneNumber)">
                        <b class="me-2">Telefon:</b>
                        <a :href="'tel:+9' + appData.fn.phoneFormat(data.student.parentPhoneNumber).replace(/ /g, '')">{{appData.fn.phoneFormat(data.student.parentPhoneNumber)}}</a>
                    </div>
                </div>
            </PreviewCard>
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.WEEKLY && data">
            <WeeklyPlanSidebar :data="data" @open-work-modal="openWeeklyWorkModal" />
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.DAILY && data">
            <AdvisorDailySidebar :data="data" />
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.LESSON && data">
            <PreviewCard css="text-yellow" icon="icon-user-graduate" title="Öğrenci">
                <div>
                    <img class="rounded-circle me-2" :src="Web.Media(data.student.profile, Web.Url(appData.default.profile))" width="32" height="32" />
                    <span class="name b-500 text-default fs-4">{{ data.student.fullName }}</span>
                </div>
            </PreviewCard>
            <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.WEEKLY_PLAN_PREVIEW})" class="card mb-3 d-block btn btn-light bg-white me-3 text-start text-dark-green">
                <i class="icon icon-folder-check text-dark-green me-2 fs-3"></i>
                <span class="fs-3 text-dark-green b-600">Haftalık Önizleme</span>
            </a>
            <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.HOW_STUDY})" class="card mb-3 d-block btn btn-light bg-white me-3 text-start text-dark-blue ">
                <i class="icon icon-study-chalkboard text-dark-blue me-2 fs-3"></i>
                <span class="fs-3 text-dark-blue b-600">Nasıl Çalışılır?</span>
            </a>
            <PreviewCard css="text-rose" icon="icon-chalkboard-user" title="Ders Hocası">
                <div class="mb-3 d-flex flex-column">
                    <span class="name b-500 text-default fs-4" v-for="r in data.lessonTeacherList" :key="r">{{ r.fullName }}</span>
                </div>
                <div class="px-4">
                    <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.LESSON_TEACHER})" class="btn btn-light radius-sm bg-white d-flex align-items-center justify-content-center  text-rose">
                        <i class="icon icon-plus text-rose pe-2 fs-3"></i>
                        <span class="fs-5 text-rose b-600">Ekle</span>
                    </a>
                </div>
            </PreviewCard>
            <PreviewCard css="text-science" icon="icon-book" title="Kaynaklarım">
                <div class="inner-bg d-flex flex-column p-3 mb-2" v-if="data.resourceList.length > 0">
                    <span class="course-resources d-block">
                        <template v-for="(r, index) in data.resourceList" :key="r">
                            <template v-if="r.isStudent">
                                <span :class="[ index < data.resourceList.length - 1 ? 'mb-2' : '' ]" class="text-white fs-6">{{ r.name }}</span>
                            </template>
                            <template v-else>
                                <hr v-if="index > 0 && data.resourceList[index - 1].isStudent" />
                                <span :class="[ index < data.resourceList.length - 1 ? 'mb-2' : '' ]" class="text-white fs-6">{{ r.name }}</span>
                            </template>
                        </template>
                    </span>
                </div>
                <div class="px-4">
                    <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.RESOURCE})" class="btn btn-light radius-sm d-flex align-items-center justify-content-center text-science">
                        <i class="icon icon-plus text-science pe-2 fs-3"></i>
                        <span class="fs-5 text-science b-600">Kaynak Ekle</span>
                    </a>
                </div>
            </PreviewCard>
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.ANALYSIS && data">
            <PreviewCard css="text-yellow" icon="icon-user-graduate" title="Öğrenci">
                <div>
                    <img class="rounded-circle me-2" :src="Web.Media(data.student.profile, Web.Url(appData.default.profile))" width="32" height="32" />
                    <span class="name b-500 text-default fs-4">{{ data.student.fullName }}</span>
                </div>
            </PreviewCard>
            <!--<template v-if="data.tyt || data.ayt">
                <PreviewCard css="text-primary" icon="icon-chart-simple" title="TYT Net Ortalama" v-if="data.tyt">
                    <NetAverage></NetAverage>
                </PreviewCard>
                <PreviewCard css="text-primary" icon="icon-chart-simple" title="AYT Net Ortalama" v-else-if="data.ayt">
                    <NetAverage></NetAverage>
                </PreviewCard>
            </template>-->
            <!--<template v-else>
                <PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Check-Up'lar" v-if="data.checkUpTest">
                    <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                        <span class="course-resources pb-2 d-block">
                            <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                            <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                            <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                        </span>
                    </div>
                </PreviewCard>
                <PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Taramalar" v-else-if="data.scanTest">
                    <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                        <span class="course-resources pb-2 d-block">
                            <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                            <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                            <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                        </span>
                    </div>
                </PreviewCard>
                <template v-else-if="data.speedTest">
                    <PreviewCard v-if="data.speedTest.processing" css="text-rose" icon="icon-clock" title="Dikkat İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                    <PreviewCard v-else-if="data.speedTest.micro" css="text-rose" icon="icon-clock" title="Mikro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                    <PreviewCard v-else-if="data.speedTest.macro" css="text-rose" icon="icon-clock" title="Makro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                </template>
            </template>-->
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.TEST && data">
            <!--<PreviewCard css="text-yellow" icon="icon-user-graduate" title="Öğrenci">
                <div>
                    <img class="rounded-circle me-2" :src="Web.Media(data.student.profile, Web.Url(appData.default.profile))" width="32" height="32" />
                    <span class="name b-500 text-default fs-4">{{ data.student.fullName }}</span>
                </div>
            </PreviewCard>
            <PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Check-Up'lar" v-if="data.checkUpTest">
                <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                    <span class="course-resources pb-2 d-block">
                        <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                        <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                        <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                    </span>
                </div>
            </PreviewCard>
            <PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Taramalar" v-else-if="data.scanTest">
                <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                    <span class="course-resources pb-2 d-block">
                        <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                        <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                        <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                    </span>
                </div>
            </PreviewCard>
            <template v-else-if="data.speedTest">
                <PreviewCard v-if="data.speedTest.processing" css="text-rose" icon="icon-clock" title="Dikkat İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                <PreviewCard v-else-if="data.speedTest.micro" css="text-rose" icon="icon-clock" title="Mikro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                <PreviewCard v-else-if="data.speedTest.macro" css="text-rose" icon="icon-clock" title="Makro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
            </template>-->
        </div>
    </RightSidebar>
    <RightSidebarMobile v-else>
        <div class="col-12" v-if="type == Enums.RIGHT_TYPE.DASHBOARD && data">
            <PreviewCard css="text-yellow" icon="icon-user-graduate" title="Öğrenci">
                <div class="mb-3">
                    <img class="rounded-circle me-2" :src="Web.Media(data.student.profile, Web.Url(appData.default.profile))" width="32" height="32" />
                    <span class="name b-500 text-default fs-4">{{ data.student.fullName }}</span>
                </div>
                <div>
                    <div class="name b-500 text-default fs-4 mb-2"><b class="me-2">Sınav Türü:</b>{{data.student.lessonAreaName}}</div>
                    <div class="name b-500 text-default fs-4 mb-2"><b class="me-2">Alan:</b>{{data.student.lessonGroupName}}</div>
                    <div class="name b-500 text-default fs-4 mb-2"><b class="me-2">Sınıf:</b>{{data.student.classRoomName}}</div>
                    <div class="name b-500 text-default fs-4" v-if="!Text.IsEmpty(data.student.phoneNumber)">
                        <b class="me-2">Telefon:</b>
                        <a :href="'tel:+9' + appData.fn.phoneFormat(data.student.phoneNumber).replace(/ /g, '')">{{appData.fn.phoneFormat(data.student.phoneNumber)}}</a>
                    </div>
                </div>
            </PreviewCard>
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.WEEKLY && data">
            <PreviewCard css="text-yellow" icon="icon-user-graduate" title="Öğrenci">
                <div>
                    <img class="rounded-circle me-2" :src="Web.Media(data.student.profile, Web.Url(appData.default.profile))" width="32" height="32" />
                    <span class="name b-500 text-default fs-4">{{ data.student.fullName }}</span>
                </div>
            </PreviewCard>
            <WeeklyWorkingTimeChart class="mb-3" v-model="data.workCount" :max="data.workMaxCount" />
            <PreviewCard css="text-purple-blue" icon="icon-pen" title="Haftalık Çözülen Soru" :value="data.questionCount + ' Soru'" />
            <PreviewCard css="text-math" icon="icon-route" title="Haftalık İlerleme">
                <div class="pt-3">
                    <ProgressBar class="blue" v-model="data.progress" :type="2" />
                </div>
            </PreviewCard>
            <!-- TODO: Danışman Puanı: teacherPoint-->
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.DAILY && data">
            <PreviewCard css="text-yellow" icon="icon-user-graduate" title="Öğrenci">
                <div>
                    <img class="rounded-circle me-2" :src="Web.Media(data.student.profile, Web.Url(appData.default.profile))" width="32" height="32" />
                    <span class="name b-500 text-default fs-4">{{ data.student.fullName }}</span>
                </div>
            </PreviewCard>
            <PreviewCard css="text-rose" icon="icon-clock" title="Günlük Çalışılan Süre" :value="appData.fn.getHour(data.workCount) + ' Saat'" />
            <PreviewCard css="text-purple-blue" icon="icon-pen" title="Günlük Çözülen Soru" :value="data.questionCount + ' Soru'" />
            <PreviewCard css="text-math" icon="icon-route" title="Günlük İlerleme">
                <div class="pt-3">
                    <ProgressBar class="blue" v-model="data.progress" :type="2" />
                </div>
            </PreviewCard>
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.LESSON && data">
            <PreviewCard css="text-yellow" icon="icon-user-graduate" title="Öğrenci">
                <div>
                    <img class="rounded-circle me-2" :src="Web.Media(data.student.profile, Web.Url(appData.default.profile))" width="32" height="32" />
                    <span class="name b-500 text-default fs-4">{{ data.student.fullName }}</span>
                </div>
            </PreviewCard>
            <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.WEEKLY_PLAN_PREVIEW})" class="card mb-3 d-block btn btn-light bg-white me-3 text-start p-3 text-dark-green ">
                <i class="icon icon-folder-check text-dark-green me-2 fs-3"></i>
                <span class="fs-3 text-dark-green b-600">Haftalık Önizleme</span>
            </a>
            <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.HOW_STUDY})" class="card mb-3 d-block btn btn-light bg-white me-3 text-start p-3 text-dark-blue">
                <i class="icon icon-study-chalkboard text-dark-blue me-2 fs-3"></i>
                <span class="fs-3 text-dark-blue b-600">Nasıl Çalışılır?</span>
            </a>
            <PreviewCard css="text-rose" icon="icon-chalkboard-user" title="Ders Hocası">
                <div class="mb-3 d-flex flex-column">
                    <span class="name b-500 text-default fs-4" v-for="r in data.lessonTeacherList" :key="r">{{ r.fullName }}</span>
                </div>
                <div class="px-4">
                    <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.LESSON_TEACHER})" class="btn btn-light radius-sm bg-white d-flex align-items-center justify-content-center text-rose ">
                        <i class="icon icon-plus text-rose me-2 fs-3"></i>
                        <span class="fs-5 text-rose b-600">Ekle</span>
                    </a>
                </div>
            </PreviewCard>
            <PreviewCard css="text-science" icon="icon-book" title="Kaynaklarım">
                <div class="inner-bg d-flex flex-column p-3 mb-2" v-if="data.resourceList.length > 0">
                    <span class="course-resources d-block">
                        <template v-for="(r, index) in data.resourceList" :key="r">
                            <template v-if="r.isStudent">
                                <span :class="[ index < data.resourceList.length - 1 ? 'mb-2' : '' ]" class="text-white fs-6">{{ r.name }}</span>
                            </template>
                            <template v-else>
                                <hr v-if="index > 0 && data.resourceList[index - 1].isStudent" />
                                <span :class="[ index < data.resourceList.length - 1 ? 'mb-2' : '' ]" class="text-white fs-6">{{ r.name }}</span>
                            </template>
                        </template>
                    </span>
                </div>
                <div class="px-4">
                    <a href="javascript:void(0);" @click="selected({ type: Enums.RIGHT_SELECTED.RESOURCE})" class="btn btn-light radius-sm d-flex align-items-center justify-content-center text-science">
                        <i class="icon icon-plus text-science me-2 fs-3"></i>
                        <span class="fs-5 text-science b-600">Kaynak Ekle</span>
                    </a>
                </div>
            </PreviewCard>
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.ANALYSIS && data">
            <PreviewCard css="text-yellow" icon="icon-user-graduate" title="Öğrenci">
                <div>
                    <img class="rounded-circle me-2" :src="Web.Media(data.student.profile, Web.Url(appData.default.profile))" width="32" height="32" />
                    <span class="name b-500 text-default fs-4">{{ data.student.fullName }}</span>
                </div>
            </PreviewCard>
            <!--<template v-if="data.tyt || data.ayt">
                <PreviewCard css="text-primary" icon="icon-chart-simple" title="TYT Net Ortalama" v-if="data.tyt">
                    <NetAverage></NetAverage>
                </PreviewCard>
                <PreviewCard css="text-primary" icon="icon-chart-simple" title="AYT Net Ortalama" v-else-if="data.ayt">
                    <NetAverage></NetAverage>
                </PreviewCard>
            </template>-->
            <!--<template v-else>
                <PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Check-Up'lar" v-if="data.checkUpTest">
                    <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                        <span class="course-resources pb-2 d-block">
                            <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                            <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                            <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                        </span>
                    </div>
                </PreviewCard>
                <PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Taramalar" v-else-if="data.scanTest">
                    <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                        <span class="course-resources pb-2 d-block">
                            <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                            <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                            <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                        </span>
                    </div>
                </PreviewCard>
                <template v-else-if="data.speedTest">
                    <PreviewCard v-if="data.speedTest.processing" css="text-rose" icon="icon-clock" title="Dikkat İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                    <PreviewCard v-else-if="data.speedTest.micro" css="text-rose" icon="icon-clock" title="Mikro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                    <PreviewCard v-else-if="data.speedTest.macro" css="text-rose" icon="icon-clock" title="Makro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                </template>
            </template>-->
        </div>
        <div class="col-12" v-else-if="type == Enums.RIGHT_TYPE.TEST && data">
            <PreviewCard css="text-yellow" icon="icon-user-graduate" title="Öğrenci">
                <div>
                    <img class="rounded-circle me-2" :src="Web.Media(data.student.profile, Web.Url(appData.default.profile))" width="32" height="32" />
                    <span class="name b-500 text-default fs-4">{{ data.student.fullName }}</span>
                </div>
            </PreviewCard>
            <!--<PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Check-Up'lar" v-if="data.checkUpTest">
                <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                    <span class="course-resources pb-2 d-block">
                        <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                        <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                        <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                    </span>
                </div>
            </PreviewCard>
            <PreviewCard css="text-science" icon="icon-book" title="Son Çözülen Taramalar" v-else-if="data.scanTest">
                <div class="inner-bg d-flex flex-column py-2 px-3 mb-3">
                    <span class="course-resources pb-2 d-block">
                        <span class="turkish text-white fs-6 pb-3 b-600">Türkçe - İsimler Testi</span>
                        <span class="math text-white fs-6 pb-3 b-600">Matematik - Problemler Testi</span>
                        <span class="social-studies text-white fs-6">Sosyal Bilgiler - Tektonik Hareketler Tesi</span>
                    </span>
                </div>
            </PreviewCard>
            <template v-else-if="data.speedTest">
                <PreviewCard v-if="data.speedTest.processing" css="text-rose" icon="icon-clock" title="Dikkat İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                <PreviewCard v-else-if="data.speedTest.micro" css="text-rose" icon="icon-clock" title="Mikro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
                <PreviewCard v-else-if="data.speedTest.macro" css="text-rose" icon="icon-clock" title="Makro İşlem Ortalama Süre" value="1 Dakika 15 Saniye" />
            </template>-->
        </div>
    </RightSidebarMobile>

     <!--<WorkTimeModal
        v-if="data"
        v-model="workModalOpen"
        :date="workDayDate"
        :minute="workMinute"
        :day-minute-list="data?.dayWorkCount ?? []"
        :week-start-date="data?.startDate"
        :week-end-date="data?.endDate"
        @save="saveWorkTime"
    />-->
</template>
<script>
    import { reactive, toRefs, computed } from "vue";

    import { Constants } from "@/helpers/constants";
    import { Enums } from "@/helpers/enums";
    import { appData, C, D } from "@/helpers/global";

    import RightSidebar from "@/layouts/_partials/RightSidebar.vue";
    import RightSidebarMobile from "@/layouts/_partials/RightSidebar.mobile.vue";

    import ProgressBar from "@/components/ProgressBar.vue";
    import NumericUpDown from "@/components/NumericUpDown.vue";

    import PreviewCard from "@/components/card/PreviewCard.vue";
    import NetAverage from "@/components/card/NetAverage.vue";
    import WeeklyWorkingTimeChart from "@/components/chart/WeeklyWorkingTimeChart.vue";
    import WeeklyPlanSidebar from "./WeeklyPlanSidebar.vue";
    import AdvisorDailySidebar from "./AdvisorDailySidebar.vue";
    //import WorkTimeModal from "@/components/modal/WorkTimeModal.vue";

    export default {
        components: {
            RightSidebar,
            RightSidebarMobile,
            
            ProgressBar,
            NumericUpDown,

            PreviewCard,
            NetAverage,
            WeeklyWorkingTimeChart,
            WeeklyPlanSidebar,
            AdvisorDailySidebar,
            //WorkTimeModal,
        },
        unmounted() { this.bus.leave(); },
        setup() {
            const e = reactive({
                bus: appData.eventBus([Constants.Key.RightSidebar, Constants.Key.RightSidebarSelected]),
                type: computed(() => {
                    return C.Int(e.bus.get(Constants.Key.RightSidebar)?.type);
                }),
                data: computed(() => {
                    return e.bus.get(Constants.Key.RightSidebar)?.data;
                }),
                workModalOpen: false,
                workDayDate: D.ServerNow(),
                workMinute: 0,
                selected(args) {
                    e.bus.set(Constants.Key.RightSidebarSelected, args);
                },
                openWeeklyWorkModal() {
                    e.selected({ type: Enums.RIGHT_SELECTED.WEEKLY_WORK_TIME });
                    
                    /*
                    e.workDayDate = e.data?.startDate
                        ? C.Date(e.data.startDate)
                        : D.ServerNow();
                    e.workMinute = 0;
                    e.workModalOpen = true;*/
                },
                /*
                saveWorkTime(event) {
                    e.workModalOpen = false;
                    e.selected({
                        type: Enums.RIGHT_SELECTED.DAILY_WORK_TIME,
                        data: {
                            action: "save",
                            studentId: C.Int(e.data?.student?.id || e.data?.studentId),
                            weeklyPlanId: C.Int(e.data?.id),
                            dayMinuteList: event?.dayMinuteList ?? [],
                        },
                    });
                }*/
            });
            return { ...toRefs(e) };
        },
    };
</script>
